module.exports = __webpack_public_path__ + "static/img/暂无数据-01.b4f4dd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/暂无数据-01.png
// module id = jU+b
// module chunks = 0